import { render, staticRenderFns } from "./PinPost.vue?vue&type=template&id=61bbcb56&scoped=true&"
import script from "./PinPost.vue?vue&type=script&lang=js&"
export * from "./PinPost.vue?vue&type=script&lang=js&"
import style0 from "./PinPost.vue?vue&type=style&index=0&id=61bbcb56&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61bbcb56",
  null
  
)

export default component.exports